export const roles = {
    ROLE_OPERATIONAL: 'ROLE_OPERATIONAL',
    ROLE_CONTROLER: 'ROLE_CONTROLER',
    ROLE_ADMINISTRATOR: 'ROLE_ADMINISTRATOR',
    ROLE_MANAGER: 'ROLE_CLUB_MANAGER',
    ROLE_GUEST: 'ROLE_GUEST'
}